import communicationQueuesResource from 'src/actions/communicationQueues/communicationQueuesResource';
import { DomainError as StandardDomainError, Unauthorized } from '@ad-scripts/application/lib/error';
import { EmailAddress } from 'src/models/Email/EmailAddress';
import { logout } from 'src/actions/auth/authSlice';
import { toastError, toastSuccess } from 'src/actions/toast';
import { translateErrors } from 'src/adapters/validateType';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import createCollectionResource from 'src/actions/shared/createResource';
import emailSenderNamesResource from './emailSenderNamesResource';
import generateId from 'src/lib/generateId';
import { EndpointTypes } from 'src/models/Channels/endpointType';

const emailAddressesResource = createCollectionResource<EmailAddress>({
  name: 'emailAddresses',
  endpoint: 'v1/orgs/:orgId/configuration/endpoints/:id',
  type: EmailAddress,
});

const createEmailAddress: sharedTypes.AppThunk =
  (payload: any) =>
  async (dispatch, getState, { gateways }) => {
    try {
      const emailEndpoint = {
        type: 'EMAIL',
        id: generateId(),
        address: payload.address,
        accountId: payload.accountId,
      };
      const senderNamePayload = {
        address: payload.address,
        senderName: payload.senderName,
      };
      dispatch(addStarted({}));
      dispatch(emailSenderNamesResource.actions.updateStarted({}));
      await gateways.emailAddresses.add(emailEndpoint);
      await gateways.emailSenderNames.replace({ accountId: payload.accountId }, senderNamePayload);

      dispatch(
        communicationQueuesResource.effects.createNewCommunicationQueue(
          { id: emailEndpoint.id, type: EndpointTypes.EMAIL },
          { disableWindowBack: true, withoutToast: true }
        )
      );

      dispatch(addSuccess({}));
      dispatch(emailSenderNamesResource.actions.updateSuccess(senderNamePayload));
      dispatch(toastSuccess(`Saved email address "${emailEndpoint.address}"`));
    } catch (err) {
      if (err instanceof StandardDomainError) {
        dispatch(addError(translateErrors(err.errors)));
      } else if (err instanceof Unauthorized) {
        dispatch(logout());
      } else {
        dispatch(addRequestError(err));
      }
      dispatch(toastError('There was an error while updating'));
    }
  };

emailAddressesResource.effects.createEmailAddress = createEmailAddress;

const { addStarted, addSuccess, addError, addRequestError } = emailAddressesResource.actions;

export default emailAddressesResource;
